import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change_language } from '../../redux/actions/A_user_actions';
import { helperLanguage } from '../../js/helpers/helperLanguage';
import { Singleton } from '../../js/Singleton';
import { iconConfig, tick } from '../../Images/Images'
import { SingletonSharedData } from '../../js/singletonSharedData';
import { CUSTOM_COMPONENTS } from '../../js/customElements/customComponents';
import ToggleButton from '../workSpace/Others/ToggleButton'
import { setCookie, getCookie } from '../../js/cookies';
import { TIME_ALWAYS_VISIBLE } from '../../constants.js';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js';
import AlertModalActions from '../../redux/actions/A_Alert_Modal';

class ConfigBar extends Component {
  constructor(props) {
    super(props);
    let langArray = [{ idLanguage: '0', textLanguage: new Singleton().getText("GUIConfigurationLanguagespanish"), selected: (new Singleton().getLanguage() === "0") },
    { idLanguage: '1', textLanguage: new Singleton().getText("GUIConfigurationLanguageenglish"), selected: (new Singleton().getLanguage() === "1") },
    { idLanguage: '2', textLanguage: new Singleton().getText("GUIConfigurationLanguageportuguese"), selected: (new Singleton().getLanguage() === "2") }];
    this.state = {
      onExit: false,
      timeVisible: true,
      languageArray: langArray,
    }
    this.language = new Singleton();
    this.sharedData = new SingletonSharedData();
    let APIFact = new APIFactory();
    this.apiCont = APIFact.buildClient();
  }
  componentWillReceiveProps() {
    let array = this.state.languageArray;
    for (let i in array) {
      array[i].selected = array[i].selected;
      let languageTags = array[i].idLanguage === '0' ? "spanish" : array[i].idLanguage === '1' ? "english" : "portuguese";
      array[i].textLanguage = new Singleton().getText("GUIConfigurationLanguage" + languageTags);
    }
    this.setState({ languageArray: array })
  }

  componentDidUpdate(prevProps) {
    if (this.props.userActions !== prevProps.userActions) {
      this.props.showAlertModal({
        type: "",
        title: this.language.getText("CallControlGUIStartStopRecordingwindowsTitle"),
        message: this.language.getText("alert-1000"),
        button: this.language.getText("CallControlGUIAssistedCallTransferaccept"),
      });
      this.closeWindow();
    }
  }

  changeSwitch(visible) {
    this.setState({ timeVisible: visible });
    setCookie(TIME_ALWAYS_VISIBLE, (visible ? "0" : "1"));
    this.props.onChangeVisibility(!visible);
  }

  changeSwitchOn = () => {
    this.changeSwitch(true);
  }
  changeSwitchOff = () => {
    this.changeSwitch(false);
  }

  selectLanguage(idLanguage) {
    let array = this.state.languageArray;
    for (let i in array) {
      array[i].selected = array[i].idLanguage === idLanguage;
    }
    this.setState({ languageArray: array })

    var _this = this;
    let languageObject = () => _this.props.change_language(_this.language.getLanguage());
    let langHelper = new helperLanguage();
    langHelper.setLanguage(idLanguage, languageObject);
  }
  closeWindow() {
    this.props.onClose();
    this.setState({ onExit: true });
  }
  render() {
    return (
      <div className={"configBar " + (this.state.onExit && "onExit")}>
        {CUSTOM_COMPONENTS["configBarHeader"](iconConfig, this.language.getText("GUIConfigurationtitle"), () => this.closeWindow())}
        <p className="textChangeLanguage">{this.language.getText("GUIConfigurationLanguagetitle")}</p>
        {this.state.languageArray.map((item) =>
          <div className="containerSettingBar margin10" key={item.idLanguage}>
            <img className={item.selected ? "itemSelected" : "itemNoSelected"} src={tick} alt={"icon"} onClick={() => this.selectLanguage(item.idLanguage)}></img>
            <p className="txtSelectionOption widht60">{item.textLanguage}</p>
          </div>)}
        <div className="separatorBarSettings"></div>
        <p className="textChangeLanguage">{this.language.getText("GUIConfigurationQueueCalltitle")}</p>
        <div className="containerSettingBar">
          <p className="txtSelectionOption">{this.language.getText("GUIConfigurationQueueCallalwaysVisible")}</p>
          <ToggleButton onOn={this.changeSwitchOn} onOff={this.changeSwitchOff} on={(getCookie(TIME_ALWAYS_VISIBLE) === "0")}
          />
        </div>
      </div>
    )
  }
}
function mapDispatchToProps(dispatch) {
  const { showAlertModal } = AlertModalActions.creators;

  return ({
    change_language: (c_language) => { dispatch(change_language(c_language)); },
    showAlertModal: (payload) => { dispatch(showAlertModal(payload)); },
  })
}

function mapStateToProps(state) {
  return {
    userActions: state.userActions,
  }
}

export default ConfigBar = connect(mapStateToProps, mapDispatchToProps)(ConfigBar);



// WEBPACK FOOTER //
// ./src/components/Header/ConfigBar.jsx